// @koala-append "accordion.js"
// @koala-append "addons.js"
// @koala-append "announcement.js"
// @koala-append "app-highlights.js"
// @koala-append "ar-badge.js"
// @koala-append "carousel.js"
// @koala-append "cart.js"
// @koala-append "common.js"
// @koala-append "contact.js"
// @koala-append "contact-script.js"
// @koala-append "countdown-timer.js"
// @koala-append "dialog.js"
// @koala-append "facets-jquery.js"
// @koala-append "format-money.js"
// @koala-append "horizontal-scroll-highlights.js"
// @koala-append "invite-friend.js"
// @koala-append "jumptech-form.js"
// @koala-append "nav.js"
// @koala-append "product-media.js"
// @koala-append "product-variants.js"
// @koala-append "scrolling-highlights.js"
// @koala-append "search.js"
// @koala-append "signup.js"
// @koala-append "slideshow.js"
// @koala-append "sticky-buy-button.js"

jQuery(function($) {
	$('.cc-accordion-item__title').click(function(evt) {
		let item = $(this).closest('.cc-accordion-item');
		let content = item.find('.cc-accordion-item__panel');

		item.toggleClass('is-open');

		// if (item.hasClass('is-open')) {
		// 	content.slideDown();
		// } else {
		// 	content.slideUp();
		// }
	});
});

document.addEventListener('DOMContentLoaded', function() {

	//######################################################################//
	//																		//
	//								CLEAR THE CART!							//
	//																		//
	//######################################################################//

	/*
	fetch('/cart/clear', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		}
	});
	 */

    /**
     * Remove add-ons from cart when an associated product is removed from the cart
     */

    const addOns = () => {

        const rows = document.querySelectorAll('.item:not(.item--add-on)');

        console.log('Rows found: ');
        console.log(rows);

        if (!rows) {
        	console.log('No rows found matching the querySelector condition, so exiting.');
            return;
        }

        rows.forEach(row => {

        	console.log('Checking row:');
        	console.log(row);

            const addOnRow = row.nextElementSibling;

            console.log('Add-on row?');
            console.log(addOnRow);

            let addOnListItems;

            if (addOnRow) {
                addOnListItems = addOnRow.querySelectorAll('.item-services-list-item');
            	console.log('Found add-on list items:');
            	console.log(addOnListItems);
            } else {
            	console.log('No add-on row found for:');
            	console.log(row);
            }

            // Remove associated add-ons when an MDA product has been removed from the cart

            const removeAddOns = () => {
            	console.log('Removing an item...');
                const removeButton = row.querySelector('.cart-remove');

                if (!removeButton || !addOnRow || !addOnRow.classList.contains('item--add-on')) {
                	console.log('Either the remove button wasn`t found, the add-on row wasn`t found, or the addonRow classes don`t contain `item--ad-on`');
                    return;
                }

                // Get main product variant ID (i.e. not the add-ons)

                let productVariantID;
                
                if (removeButton.dataset.variant) {
                    productVariantID = removeButton.dataset.variant;
                }

                // Place add-on variants into an array
                
                let variants = [productVariantID];
                let qty = 0;
                let data = { updates: {} };

                if (addOnListItems) {
                    addOnListItems.forEach(addOnListItem => {
                        variants.push(addOnListItem.dataset.variant);
                    });
                }

                if (variants.length > 0) {
                    variants.forEach(variant => {
                        data.updates[variant] = qty;
                    });
                }

                console.log('Data:');
                console.log(data);

                console.log('Variants:');
                console.log(variants);

                removeButton.addEventListener('click', (evt) => {
                	console.log('Remove button clicked!');

                    evt.preventDefault();

                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    }).then((data) => {
                        if (data.status === 200) {
                            window.location.reload();
                        } else {
                            console.log('Request returned an error', data);
                        }
                    }).catch((error) => {
                        console.log('Request failed', error)
                    });

                });
            }

            removeAddOns();

            // Update quantity of add-on when an MDA product has its quantity updated

            const updateAddOnsQty = () => {
                const qtyInput = row.querySelector('.quantity');
                const qtyBtns = row.querySelectorAll('.qty-btn');

                if (!qtyInput && !qtyBtns) {
                    return;
                }

                qtyBtns.forEach(qtyBtn => {
                    qtyBtn.addEventListener('click', (evt) => {
                        let qtyValue;
                        if (qtyBtn.dataset.direction === '-') {
                            if (Number(qtyInput.value) > 1) {
                                qtyValue = Number(qtyInput.value) - 1;
                            } else {
                                qtyValue = 1;
                            }
                        } else {
                            qtyValue = Number(qtyInput.value) + 1;
                        }

                        if (addOnListItems) {
                            addOnListItems.forEach(addOnListItem => {
                                // Update the quantity string for the add-on
                                const qtyStr = addOnListItem.querySelector('.item-services-list-item__qty');
                                qtyStr.innerHTML = qtyValue + ' x';

                                // Find the hidden add-on product in the cart and update its quantity
                                // This change will then be reflected when the customer clicks the "Update Basket" button
                                const variantID = addOnListItem.dataset.variant;
                                const addOnProductItem = document.querySelector('.item[data-variant="' + variantID + '"]');
                                if (variantID && addOnProductItem) {
                                    const addOnProuductQty = addOnProductItem.querySelector('.quantity');
                                    if (addOnProuductQty) {
                                        addOnProuductQty.value = qtyValue;
                                    }
                                }
                            });
                        }
                    });
                });
            }

            updateAddOnsQty();

        });

    }

    addOns();

});

jQuery(function($) {
	//	No announcement bar? No dice.
	
	if ($('.announcement-wrapper').length < 1) {
		return;
	}

	let announcement = $('#shopify-section-header .announcement');
	let wrapper = announcement.find('.announcement-wrapper');

	let interval = parseInt(announcement.css('--interval')) * 1000;

	setInterval(function() {
		let slides = parseInt(announcement.css('--blocks'));
		let next = parseInt(announcement.css('--current')) + 1;

		if (next >= slides) {
			next = 0;
		}

		announcement.css({ '--current': next });
	}, interval);
});

jQuery(function($) {
	if ($('.app-highlights').length) {

		$('.app-highlights .highlight').click(function(e) {
			let parent = $(this).closest('.app-highlights');
			let index = $(this).attr('data-index');
			let image = parent.find('.highlight-block[data-index="' + index + '"]');

			parent.find('.highlight').removeClass('highlighted');
			parent.find('.highlight-block').removeClass('showing');

			$(this).addClass('highlighted');
			image.addClass('showing');
		});
	}
});

jQuery(function($) {

	//	Only do this if we're on a PDP, and there's an energy-rating / product badge element

	if ($('.pdp-image-top-right').length < 1) {
		return;
	}

	function calcARMargin() {
		let _top = parseInt($('.pdp-image-top-right').css('top'));
		let _height = parseInt($('.pdp-image-top-right').outerHeight());
		let _margin = _top + _height;

		$('.media-gallery').css('--sale-pill-height', _margin + 'px');
	}

	//	The '--top' attribute will be lost when the PDP is updated via ajax (e.g. when fetching a variant), so we need to account for that

	$(document.body).on('variant_changed_complete', function(evt) {
		calcARMargin();
	});
});

jQuery(function($) {
	$('.carousel-section').each(function(index) {
		let carousel = $(this);
		let current = 0;	//	Always start on the first one

		updateCurrentSlide(carousel, current);

		initCarousel(carousel);
	});

	function initCarousel(carousel) {
		//	Show the play icon
		
		carousel.find('.action .play-icon').hide();
		carousel.find('.action .pause-icon').show();

		//	Remove any pause

		carousel.removeClass('paused');

		//	Kick off the timer

		clearTimeout(carousel.get(0).timeout);
		
		let interval = parseInt(carousel.css('--interval')) * 1000;

		let timeoutID = setTimeout(function() {
			let next = getNext(carousel, 1);

			updateCurrentSlide(carousel, next);

			initCarousel(carousel);
		}, interval, carousel);

		carousel.get(0).timeout = timeoutID;
	}

	//	Prev / next

	$('.carousel-controls .skip-slide').click(function(evt) {
		let carousel = $(this).closest('.carousel-section');
		let amount = parseInt($(this).attr('data-amount'));

		let next = getNext(carousel, amount);

		updateCurrentSlide(carousel, next);

		initCarousel(carousel);
	});

	//	Play / pause

	$('.carousel-controls .action').click(function(evt) {
		let carousel = $(this).closest('.carousel-section');
		let button = $(this);

		let wasPlaying = (button.find('.play-icon:visible').length) ? false : true;

		button.find('svg').hide();

		//	If it WAS playing at the time of the click, then they hit 'pause', so let's pause it

		if (wasPlaying) {
			clearTimeout(carousel.get(0).timeout);
			button.find('.play-icon').show();
			carousel.addClass('paused');
		} else {
			initCarousel(carousel);
			button.find('.pause-icon').show();
		}
	});

	//	When a .dot is clicked, force-scroll to that slide

	$('.carousel-section .dots .dot button').click(function(evt) {
		let carousel = $(this).closest('.carousel-section');
		let button = $(this);

		let next = $(this).closest('.dot').index();

		updateCurrentSlide(carousel, next);

		initCarousel(carousel);
	});

	//	Update the carousel with the `current` slide

	function updateCurrentSlide(carousel, next) {
		carousel.css({ '--current': next });

		carousel.find('.carousel__slide').removeClass('current');
		carousel.find('.carousel__slide:nth-of-type(' + (next + 1) + ')').addClass('current');

		carousel.find('.dots .dot').removeClass('current');
		carousel.find('.dots .dot:nth-of-type(' + (next + 1) + ')').addClass('current');
	}

	//	Logic for getting the next slide number

	function getNext(carousel, amount) {
		let slides = parseInt(carousel.css('--slides'));
		let next = parseInt(carousel.css('--current')) + amount;

		if (next >= slides) {
			next = 0;
		}

		if (next < 0) {
			next = slides - 1;
		}

		return next;
	}
});

jQuery(function($) {
	///
	//	Warning on cart page - ajax functions don't work when console is open!
	///

	if ($('body').hasClass('template-cart')) {
		console.log('%c Important!', 'font-weight: bold; font-size: 50px; color: #EE5253; text-shadow: 3px 3px 0 #ff9f43, 6px 6px 0 #feca57, 9px 9px 0 #1dd1a1, 12px 12px 0 #48dbfb, 15px 15px 0 rgb(2,135,206) , 18px 18px 0 #5f27cd, 21px 21px 0 #ff9ff3; margin-bottom: 12px; padding: 1rem;');
		console.log('%c Cart updates won`t work if the console/inspector panel is open. Close this panel!', 'font-weight: bold; font-size: 24px; background-color: #B33771; color: #FFFFFF; padding: 0.500rem');
	}

	///
	//	Whenever the cart is updated via liquid-ajax-cart, listen and check for any variants that shouldn't be there
	///

	document.addEventListener('liquid-ajax-cart:request-end', function(event) {
		removeOrphanedItems();
	});

	//	Function to remove orphaned add-on services

	function removeOrphanedItems() {
		console.log('Removing orphaned items...');

		let data = { updates: {} };

		let isAddOnArray = [];
		let serviceListArray = [];

		//	Step 1: Find every .item.is-addon element
		
		$('.item.is-addon').each(function() {
			var variant = $(this).attr('data-variant');
			
			isAddOnArray.push(variant);
		});

		//	Step 2: Find every .item--add-on element and extract data-variant from .item-services-list-item

		$('.item--add-on').each(function() {
			$(this).find('.item-services-list-item').each(function() {
				var variant = $(this).attr('data-variant');

				serviceListArray.push(variant);
			});
		});

		// Step 3: Loop through isAddOnArray and check against serviceListArray

		if (isAddOnArray.length > 0) {
			isAddOnArray.forEach(function(variant) {
				if (serviceListArray.indexOf(variant) === -1) {
					data.updates[variant] = 0;
				}
			});
		}

		if (Object.keys(data.updates).length === 0) {
			//	Do nothing

			console.log('`data.updates` appears to be empty, so doing nothing.');
		} else {
			//	Update the cart to remove the orphaned add-ons

			console.log('Looks like `data.updates` has some data, so updating the cart.');

			liquidAjaxCart.update(data, {});
		}
	}

	//	Check on load

	removeOrphanedItems();
});

document.addEventListener('DOMContentLoaded', () => {

    /**
     * Fixes vh unit in touch devices
     */
    const setVh = () => {

        const handleVh = () => {
            // get the viewport height and multiply it by 1% to get a value for a vh unit
            // then set the value in the --vh custom property to the root of the document
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty(`--vh`, `${vh}px`);
        }

        handleVh();
        window.addEventListener(`resize`, handleVh, false);

    }

	/**
	 * Header section
	 */
	// const header = () => {

	// 	const handleToggle = () => {
	// 		const button = document.querySelector(`.header__toggle`);
	// 		if (!button) {
	// 			return;
	// 		}
	// 		button.addEventListener(`click`, () => {
	// 			button.classList.toggle(`header__toggle--open`);
	// 		});
	// 	}

	// 	handleToggle();

	// }

	/**
	 * Search modal
	 */
	// const searchModal = () => {
	// 	const header = document.querySelector(`.header`);
	// 	const trigger = document.querySelector(`.header__search-btn`);
	// 	const modal = document.querySelector(`.search-modal`);
	// 	const openClass = `search-modal--open`;

	// 	if (!trigger || !modal) {
	// 		return;
	// 	}

	// 	const input = modal.querySelector(`.search-form__input`);

	// 	const hideModal = () => {
	// 		modal.classList.remove(openClass);
	// 		if (input) {
	// 			setTimeout(() => {
	// 				input.blur();
	// 			}, 100);
	// 		}
	// 	}

	// 	const showModal = () => {
	// 		modal.classList.add(openClass);
	// 		if (input) {
	// 			setTimeout(() => {
	// 				input.focus();
	// 			}, 100);
	// 		}
	// 	}

	// 	trigger.addEventListener(`click`, () => {
	// 		if (modal.classList.contains(openClass)) {
	// 			hideModal();
	// 		} else {
	// 			showModal();
	// 		}
	// 	});

	// 	if (header) {
	// 		header.addEventListener(`click`, (evt) => {
	// 			if (evt.target === header && modal.classList.contains(openClass)) {
	// 				hideModal();
	// 			}
	// 		});
	// 	}
	// }

	/**
	 * Search form snippet
	 */
	const searchForm = () => {
		const forms = document.querySelectorAll(`.search-form`);
		if (!forms) {
			return;
		}
		forms.forEach(form => {
			const input = form.querySelector(`.search-form__input`);
			const clearBtn = form.querySelector(`.search-form__btn--clear`);
			if (!input && !clearBtn) {
				return;
			}
			clearBtn.addEventListener(`click`, () => {
				input.value = ``;
				input.focus();
			});
		});
	}

    /**
     * Chocks away!
     */
    setVh();
	// header();
	// searchModal();
	searchForm();

});

///
//	jQuery handler for the DOM
///

let _debounce;
let isMobile;

jQuery(function($) {
	// Is on mobile currently?
	
	isMobile = function() {
		if ($('#mobilepixel').is(':visible')) {
			return true;
		}
		
		return false;
	}
	
	///
	//	Debounce function to only run expensive iterations once
	///
	
	_debounce = function(func, wait, immediate) {
		var timeout, args, context, timestamp, result;
		
		var later = function() {
			var last = new Date().getTime() - timestamp;
			
			if (last < wait && last >= 0) {
				timeout = setTimeout(later, wait - last);
			} else {
				timeout = null;
				
				if (!immediate) {
					result = func.apply(context, args);
					if (!timeout) context = args = null;
				}
			}
		};
		
		return function() {
			context = this;
			args = arguments;
			timestamp = new Date().getTime();
			var callNow = immediate && !timeout;
			if (!timeout) timeout = setTimeout(later, wait);
			
			if (callNow) {
				result = func.apply(context, args);
				context = args = null;
			}
			
			return result;
		};
	};
});

///
//	JS sprintf function
//
//	Usage: 'We are not in {place} anymore.'.formatUnicorn({ place: 'Kansas' })
///

String.prototype.formatUnicorn = String.prototype.formatUnicorn || function () {
	"use strict";
	var str = this.toString();
	if (arguments.length) {
		var t = typeof arguments[0];
		var key;
		var args = ("string" === t || "number" === t) ?
			Array.prototype.slice.call(arguments)
			: arguments[0];
			
		for (key in args) {
			str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
		}
	}

	return str;
};

jQuery(function($) {
	///
	//	Check for when the general form subject is changed
	///

	if ($('#contact_enquiry_type').length) {

		let orderNumberField = $('.large_form.order-number');
		let orderNumberLabel = orderNumberField.find('label');
		let orderNumberInput = orderNumberField.find('input');

		orderNumberField.hide();

		$('.large_form').on('input paste blur change', '#contact_enquiry_type', function(e) {

			let enquiryType = $(this).val();

			if (enquiryType == 'technical' || enquiryType == 'order' || enquiryType == 'delivery' || enquiryType == 'returns') {
				orderNumberField.show();
				orderNumberLabel.addClass('is-required');
				orderNumberInput.prop('required', true);
				orderNumberInput.attr('aria-required', 'true');
			} else {
				orderNumberField.hide();
				orderNumberLabel.removeClass('is-required');
				orderNumberInput.prop('required', false);
				orderNumberInput.attr('aria-required', 'false');
			}
		});

		$('#contact_enquiry_type').trigger('change');
	}
});

jQuery(function($) {

	//	If there's no form on this page, then let's just skip the whole thing

	if ($('.general-form').length < 1) {
		return;
	}

	//	If it's a 'regular' form, also skip the whole thing

	if ($('.general-form').hasClass('regular')) {
		return;
	}

	//	Otherwise, carry on

	let formContainer = $('.general-form');
	let contactForm = $('.general-form form');

	//	Hide the order number field and the order item selector initially

	let orderNumContainer = $('.large_form.order-number');
	let orderNumField = $('#contact_order_number');
	orderNumContainer.hide();

	let orderItemContainer = $('.large_form.order-item');
	let orderItemField = $('#contact_order_item');
	let validOrderText = orderItemField.attr('data-valid-order');
	let orderItemBlankOption = '<option value="">' + validOrderText + '</option>';
	orderItemContainer.hide();

	$('.at-last-button').hide();

	let isSubmitting = false;

	///
	//	'Regular' form submission: if the form has been posted, then let's collapse it
	///

	let formHasBeenPosted = (typeof(formPosted) == 'undefined') ? false : formPosted;

	if (formHasBeenPosted) {
		$('.form-internal-wrapper').slideUp();
	}

	///
	//	Now elements are hidden: If the ajax_url isn't defined, let's just bomb out - it just means we won't try to ajax-process the form
	///

	let ajaxDefined = true;
	let sfEnabled = false;

	if (typeof(contactFormConfig) == 'undefined') {
		ajaxDefined = false;
	}

	if (typeof(contactFormConfig) == 'undefined' || typeof(contactFormConfig.ajax_url) == 'undefined' || contactFormConfig.ajax_url == '') {
		ajaxDefined = false;
	}

	//	Is SalesForce integration ensabled?
	
	if (typeof(contactFormConfig) != 'undefined' && typeof(contactFormConfig.enable_salesforce) != 'undefined' && contactFormConfig.enable_salesforce == 'true') {
		sfEnabled = true;
	}

	//	The AJAX URL isn't defined, so we need to hide the 'Find Order' button, as the UK will just accept a typed order number. No need to retrieve the order items

	if (!ajaxDefined) {
		$('button.find-order').closest('.box').hide();
	}

	//	Remove the default form action & method, but ONLY if SalesForce integration is off

	if (sfEnabled) {
		$('#contact_form').removeAttr('action');
		$('#contact_form').removeAttr('method');
	}

	///
	//	Live-validate the form
	///

	contactForm.on('paste blur change', 'input, textarea, select', function(e) {
		let field = $(this);
		let fieldID = field.attr('id');
		let container = field.closest('.large_form');
		let label = container.find('label');

		let isRequired = field.prop('required');
		let fieldVal = field.val();
		let fieldType = field.attr('type');

		showError(field, container, false);

		//	Check if the 'Enquiry Type' field was changed

		if (fieldID == 'contact_enquiry_type') {
			let selectedOption = field.find('option:selected');
			if (selectedOption.is('[data-for-order]')) {
				showOrderFields(true);
			} else {
				showOrderFields(false);
			}
		}

		//	Is the field required?

		if (isRequired) {
			if (fieldVal == '') {
				showError(field, container, true);
			}

			if (fieldType == 'email' && !checkEmail(fieldVal)) {
				showError(field, container, true);
			}
		}

		//	If the order number field is required (which means it's showing) and it isn't blank, check it!
		//	...but ONLY if we're not also submitting the form (otherwise it will reset the product dropdown)

		if (!isSubmitting) {
			if (fieldID == 'contact_order_number' && field.val() != '' && field.prop('required')) {

				//	Only check the order if the email looks valid

				if (checkEmail($('#contact_email').val())) {
					checkOrderDetails();
				} else {
					$('#contact_email').blur();
				}
			}

			//	As above, but the other way around: if the email field is changed and the order number field has been completed, then we need to check it

			if (fieldID == 'contact_email' && checkEmail($('#contact_email').val()) && orderNumField.prop('required')) {
				//	Only check the order if there's an order number available

				if (orderNumField.val() != '') {
					checkOrderDetails();
				} else {
					orderNumField.blur();
				}
			}
		}
	});

	///
	//	Trigger live validation on initial page load
	///

	contactForm.find('input, select, textarea').each(function(index) {
		let field = $(this);

		if (field.val() != null && field.val().length > 0) {
			field.blur();
		}
	});

	///
	//	Check for an order when the magic button is clicked
	///

	$('body').on('click', '.find-order', function(evt) {
		evt.preventDefault();

		console.log('Clicking button to find order...');

		$('#contact_order_number').blur();
	});

	///
	//	Enable/disable form when it's loading
	///

	function enableForm(bool) {
		if (bool) {
			formContainer.removeClass('sending');
		} else {
			formContainer.addClass('sending');
		}
	}

	/////
	///
	//	FORM SUBMISSION
	///
	/////

	$(document).on('submit', '.general-form form', function(e) {
		e.preventDefault();

		if (formContainer.hasClass('sending')) {
			return false;
		}

		enableForm(false);
		
		var _form = $(this);

		isSubmitting = true;
		
		//	Let's try to trigger those errors ON PORPOISE
		
		_form.find('input, textarea, select').trigger('change');
		
		if (_form.find('.error').length) {
			
			//	No dice. Errors will be shown.
			
			enableForm(true);
			isSubmitting = false;
			return false;
		}

		//	If the AJAX URL isn't available, OR of SalesForce integration isn't enabled, then we want to return TRUE to actually submit the form

		if (!ajaxDefined || !sfEnabled) {
			console.log('ajax_url is not defined; or SF integration is disabled, so we should just be submitting this form.');
			$('.general-form form').off('submit');
			this.submit();
			return true;
		}

		//	Otherwise, let's send the form
		
		sendForm();

		isSubmitting = false;

		return false;
	});

	///
	//	Show/hide errors
	///

	function showError(field, container, bool) {
		if (!bool) {
			container.find('.error').remove();
		} else {
			if (!container.find('.error').length) {
				container.append('<p class="error red">' + container.attr('data-error') + '</p>');
			}
		}
	}

	///
	//	Show/hide the order fields
	///

	function showOrderFields(bool) {
		orderNumField.prop('required', bool);
		orderNumContainer[(bool) ? 'show' : 'hide']();

		$('.at-last-button').hide();

		console.log('showOrderFields triggered - at-last button has been hidden');

		//	We only want to show the order number field if the AJAX URL isn't defined, so let's exit here

		if (!ajaxDefined) {
			return;
		}

		orderItemField.prop('required', bool);

		if (bool) {
			console.log('Arg for `showOrderFields` was TRUE, so showing the order fields...');

			orderNumContainer.show();
			orderItemContainer.show();

			if (checkEmail($('#contact_email').val()) && orderNumField.val() != '') {
				checkOrderDetails();
			}

			if (orderItemField.find('option').length < 1) {
				console.log('There was nothing in the order item field, so populating it with a blank option');

				orderItemField.empty();
				orderItemField.append(orderItemBlankOption);
			}

		} else {
			orderNumContainer.hide();
			orderItemContainer.hide();

			orderNumField.val('');

			$('#contact_order_id').val('');
			$('#contact_order_date').val('');

			orderItemField.empty();
			orderItemField.append(orderItemBlankOption);

			console.log('Arg for `showOrderFields` was FALSE, so should have just entered a `Enter a valid order` option to the order item dropdown...');
		}
	}

	///
	//	Let's check the order details
	///

	function checkOrderDetails() {
		if (formContainer.hasClass('sending') || !ajaxDefined) {
			return false;
		}

		//	Remove any error messages

		orderNumContainer.find('.error').remove();

		//	Clear the dropdown of any current items

		orderItemField.empty();
		orderItemField.append(orderItemBlankOption);

		let orderNum = orderNumField.val().replace('#', '');

		console.log('Should have just entered a `Enter a valid order` option to the order item dropdown...');

		let sendData = {};
		sendData['action'] = 'get_order';
		sendData['email'] = $('#contact_email').val();
		sendData['order'] = orderNum;
		sendData['country'] = Shopify.country;
		sendData['store'] = Shopify.shop;

		sendAjaxRequest(sendData, 'order_update', 'order_fail');
	}

	///
	//	Order lookup was successful, so update the order items dropdown
	///

	$(document.body).on('order_update', function(evt, data) {
		console.log(data);

		if (data.response != 'success') {
			$('body').trigger('order_fail', [data]);
			return;
		}

		$('#contact_order_id').val(data.details.id);
		$('#contact_order_date').val(data.details.date);

		//	Add a data-order attribute to the field so we have something to compare to on subsequent checks

		orderNumField.attr('data-order', orderNumField.val());

		//	Create the order item options

		orderItemField.empty();

		console.log('Emptying order field but NOT adding default `choose valid order` because we should already have a valid order...');

		$.each(data.details.items, function(index, item) {
			console.log(item);

			orderItemField.append('<option value="' + item.sku + '">' + item.name + '</option>');
		});

		maybeShowAtLast(data);

	});

	///
	//	Maybe show the At-Last button
	///

	function maybeShowAtLast(data) {
		$('.at-last-button').hide();

		//	If `At-Last` is enabled, should we show the At-Last return button?

		if (typeof(contactFormConfig.enable_atlast) != 'undefined' && contactFormConfig.enable_atlast == 'true') {

			//	Is this for a return?

			let contactType = $('#contact_enquiry_type').val();

			if (contactType == 'returns') {

				// Parse the order date string into a JS Date object

				let orderDate = new Date(data.details.date);

				// Create a comparison date for March 1st, 2024

				let march2024 = new Date('2024-03-01');

				// Check if the parsed date is after March 1st, 2024

				if (orderDate > march2024) {
					$('at-last').css({
						'--button-width': 'auto',
						'--button-height': 'auto',
						'--button-text-font-size': '1rem'
					});

					$('.at-last-button').show();
				}
			}
		}
	}

	///
	//	Order lookup failed, so show an error
	///

	$(document.body).on('order_fail', function(evt, data) {
		console.log(data);

		let error = contactFormConfig[data.message_key];

		orderNumContainer.append('<p class="error red">' + error + '</p>');
	});

	///
	//	Attempt to send to Salesforce
	///

	function sendForm() {
		let sendData = {};
		sendData['action'] = 'submit';
		sendData['name'] = $('#contact_name').val();
		sendData['email'] = $('#contact_email').val();
		sendData['phone'] = $('#contact_phone').val();
		sendData['type'] = $('#contact_enquiry_type').val();
		sendData['message'] = $('#message').val();
		sendData['country'] = Shopify.country;
		sendData['store'] = Shopify.shop;

		let selectedOption = $('#contact_enquiry_type').find('option:selected');

		if (selectedOption.is('[data-for-order]')) {
			sendData['order'] = orderNumField.val();
			sendData['order_id'] = $('#contact_order_id').val();
			sendData['order_date'] = $('#contact_order_date').val();
			sendData['item'] = $('#contact_order_item').val();
		}

		sendAjaxRequest(sendData, 'submit_success', 'submit_fail');

		return false;
	}

	///
	//	Submitting form was successful, so let's collapse it!
	///

	$(document.body).on('submit_success', function(evt, data) {
		console.log(data);

		if (data.response != 'success') {

			//	Let's see if it was something Salesforce rejected, rather than a 'regular' error

			if (data.message_key == 'send_error') {
				data.error_message = data.details.error;
			}

			$('body').trigger('submit_fail', [data]);
			return;
		}

		let ticketID = data.details.case_id;
		let response = contactFormConfig['thankyou'].formatUnicorn({ ticket_id: ticketID })

		$('.page-copy').remove();
		$('.form-response').html(response);
		formContainer.slideUp();
	});

	///
	//	Order lookup failed, so show an error
	///

	$(document.body).on('submit_fail', function(evt, data) {
		console.log(data);

		let error = contactFormConfig[data.message_key];

		if (data.error_message) {
			error = data.error_message;
		}

		$('#message').closest('.large_form').append('<p class="error red">' + error + '</p>');
	});

	///
	//	Abstracted function for sending ajax request to app
	///

	function sendAjaxRequest(sendData, successAction, failAction) {
		enableForm(false);

		$.ajax({
			url: contactFormConfig.ajax_url,
			type: 'POST',
			data: sendData,
			dataType: 'json',
			
			success: function(data) {
				enableForm(true);

				$('body').trigger(successAction, [data]);
			},

			error: function(xhr, ajaxOptions, thrownError) {
				console.log(xhr.response);
				console.log(xhr.message);
				console.log(thrownError);

				enableForm(true);
				
				alert(thrownError);

				// $('body').trigger(failAction, xhr.message);
			}
		});
	}

	///
	//	Check email validity
	///

	function checkEmail(email) {
		let emailFilter = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		return emailFilter.test(email);
	}

	///
	//	Safely encode attributes
	///

	function quoteattr(s, preserveCR) {
		preserveCR = preserveCR ? '&#13;' : '\n';

		return ('' + s) /* Forces the conversion to string. */
		.replace(/&/g, '&amp;') /* This MUST be the 1st replacement. */
		.replace(/'/g, '&apos;') /* The 4 other predefined entities, required. */
		.replace(/"/g, '&quot;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		/*
		You may add other replacements here for HTML only 
		(but it's not necessary).
		Or for XML, only if the named entities are defined in its DTD.
		*/ 
		.replace(/\r\n/g, preserveCR) /* Must be before the next replacement. */
		.replace(/[\r\n]/g, preserveCR);
	}
});

jQuery(function($) {

	$('.countdown-wrapper').each(function(index) {
		var clock = $(this);
		var deadline = new Date(parseInt(clock.attr('data-deadline')) * 1000);
		
		setClock(clock, deadline);
		
		setInterval(function() { setClock(clock, deadline) }, 1000);

		clock.closest('.countdown-timer').removeClass('invisible');
	});
	
	function setClock(clock, deadline) {
		var datetime_now = Math.floor($.now());
		milliseconds = deadline - datetime_now;
		
		//	We don't want to continue if there's no time left

		if (milliseconds < 1000) {
			let bar = clock.closest('.announcement-inner');

			if (bar.length) {
				bar.remove();
			}
			
			return;
		}

		var delta = Math.abs(deadline - datetime_now) / 1000;
		
		var days = Math.floor(delta / 86400);
		delta -= days * 86400;
		
		var daysOnes = days % 10;
		var daysTens = (days - daysOnes) / 10;
		
		clock.find('.time-part-wrapper.days .time-part.tens').attr('data-time', daysTens);
		clock.find('.time-part-wrapper.days .time-part.ones').attr('data-time', daysOnes);
		
		var hours = Math.floor(delta / 3600) % 24;
		delta -= hours * 3600;
		
		var hoursOnes = hours % 10;
		var hoursTens = (hours - hoursOnes) / 10;
		
		clock.find('.time-part-wrapper.hours .time-part.tens').attr('data-time', hoursTens);
		clock.find('.time-part-wrapper.hours .time-part.ones').attr('data-time', hoursOnes);
		
		var minutes = Math.floor(delta / 60) % 60;
		delta -= minutes * 60;
		
		var minutesOnes = minutes % 10;
		var minutesTens = (minutes - minutesOnes) / 10;
		
		clock.find('.time-part-wrapper.minutes .time-part.tens').attr('data-time', minutesTens);
		clock.find('.time-part-wrapper.minutes .time-part.ones').attr('data-time', minutesOnes);
		
		var seconds = Math.floor(delta % 60);
		
		var secondsOnes = seconds % 10;
		var secondsTens = (seconds - secondsOnes) / 10;
		
		clock.find('.time-part-wrapper.seconds .time-part.tens').attr('data-time', secondsTens);
		clock.find('.time-part-wrapper.seconds .time-part.ones').attr('data-time', secondsOnes);
		
		// console.log(days, hours, minutes, seconds);
	}
});

jQuery(function($) {

	let $body = $('body');

	///
	//	Turn buttons & links into triggers for checkboxes
	///

	$body.on('click', 'a[data-for], button[data-for]', function(evt) {
		var trigger = $($(this).attr('data-for'));
		
		trigger.prop('checked', !trigger.prop('checked')).trigger('change');
	});

	///
	//	Similar but different functionality for triggering modals
	///

	$body.on('click', '[data-modal]', function (evt) {
		let targetModal = $($(this).attr('data-modal')).get(0);
		targetModal.showModal();
	});

	$body.on('click', '.close-modal', function (evt) {
		let targetModal = $(this).closest('dialog').get(0);
		targetModal.close();
	});
	
	//	The `dialog` element actually occupies the entire viewport, so clicking anywhere on it will close it

	$body.on('click', 'dialog', function (evt) {
		let targetModal = $(this).get(0);
		targetModal.close();
	});
	
	//	The `dialog` element needs to contain a `.dialog-content` that will prevent the propagation of the closing click on the `dialog` element

	$body.on('click', '.dialog-content', function (evt) {
		evt.stopPropagation();
	});

	//	launch a dialog based on a JS event

	$(document.body).on('show_dialog', function(evt, data) {
		console.log(data);

		if (data.dialog && $(data.dialog).length) {
			let targetModal = $(data.dialog).get(0);

			if (data.content) {
				$(data.dialog).find('.text').append(data.content);

				targetModal.showModal();
			} else {
				console.log('No content was passed for the dialog to show!');
			}
		} else {
			console.log('No valid dialog was found! Selector: [' + data.dialog + ']');
		}
	});
});


jQuery(function($) {
	let ajaxURL = window.location.pathname;

	let filterAside = $('#main-collection-filters');
	let sortDropdown = $('#sort-by');
	let filtersForm = $('#filters').get(0);
	let filterButton = $('.js-apply-filters');

	let activeFiltersBar = $('.active-filters');

	//	There's no filter panel, so let's just skip all of this

	if (filterAside.length < 1) {
		return;
	}

	//	Numbers only in number inputs

	$('input[type="number"]').on('input', function (e) {
		$(this).val($(this).val().replace(/[^0-9]/g, ''));
	});

	//	When the 'sort' dropdown is changed

	sortDropdown.change(function(e) {
		sendAjaxRequest();
	});

	//	When any sidebar filters are changed

	filterAside.on('input change', '.filters', _debounce(sendAjaxRequest, 500));

	//	When an 'active filter' button is clicked (i.e. the grey filter buttons flow the title bar)

	activeFiltersBar.on('click', '.active-filters__item', function(e) {
		e.preventDefault();
		
		let filterURL = $(this).attr('href');
		let param = filterURL.split('?').pop();

		sendAjaxRequest(param);
	});

	///
	//	Abstracted function for sending ajax request to results
	///

	function sendAjaxRequest(passedParams = null) {

		//	Blank out the grid and the filter panel

		let grid = $('#product-grid');

		$('body').addClass('ajax-loading');

		let params = passedParams;

		//	If no search parameters have been passed, then use the filter form

		if (!passedParams || typeof passedParams != 'string') {
			console.log('passedParams is null or undefined, so grabbing it from the filter...');
			//	Collate the filters

			var formData = new FormData(filtersForm);

			let sort = sortDropdown.find('option:selected').val();
			let searchParams = new URLSearchParams(formData);

			searchParams.set('sort_by', sort);

			params = searchParams.toString();

		} else {
			console.log('passedParams is defined');
		}

		console.log('params:', params);

		let requestURL = ''.concat(ajaxURL, '?').concat(params);

		console.log(requestURL);

		updateURL(params);

		$.ajax({
			url: requestURL,
			type: 'GET',
			
			success: function(data) {
				//	Replace product grid

				let grid = $('#product-grid');
				let newGrid = $(data).find('#product-grid');
				
				grid.replaceWith(newGrid);

				//	Replace 'active filters'

				let filters = $('.active-filters');
				let activeFilters = $(data).find('.active-filters');
				
				filters.replaceWith(activeFilters);
				
				//	Replace filter accordion

				let accordion = $('.filters__main');
				let newAccordion = $(data).find('.filters__main');

				accordion.replaceWith(newAccordion);

				//	Update results count

				// let resultCountString = newGrid.attr('data-count');
				// filterButton.text(resultCountString);


				$('body').removeClass('ajax-loading');

				//	Trigger a custom event

				$('body').trigger('filters_applied');
			},

			error: function(xhr, ajaxOptions, thrownError) {
				console.log(xhr.response);
				console.log(xhr.message);
				console.log(thrownError);

				alert(thrownError);
			}
		});
	}

	///
	//	Update the URL
	///

	function updateURL(searchParams) {
		history.pushState({ searchParams }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));
	}

	///
	//	Close the filter sidebar on escape key
	///

	document.onkeydown = function(evt) {
		evt = evt || window.event;

		console.log(evt.keyCode);

		//	27 = Escape

		if (evt.keyCode == 27) {
			$('#filter-trigger').prop('checked', false);
		}
	};

	/////
	///
	//	When a filter has been updated, we want to fetch the options and remove any variants that don't match
	///
	/////

	$(document.body).on('filters_applied', function(evt) {
		//	If there aren't any variant cards, we can skip this entirely

		if ($('.variant-card').length < 1) {
			return;
		}

		//	Let's see what filters have actually been picked

		let selectedFilters = {};

		let min_price = 0;
		let max_price = 0;

		$('.filters__main .filter-group').each(function(index) {
			let group = $(this);
			let name = group.attr('data-name');
			let type = group.attr('data-type');

			//	The `product_type` filter automatically adds `filter-p-` to the start of it, so let's remove that

			name = name.replace('filter-p-', '');

			//	For 'list' types (like Colour, Load Size, etc.)

			if (type == 'list') {

				//	Now let's get all the selected, available inputs

				let options = group.find('input:checked:not(:disabled)');

				selectedFilters[name] = [];

				options.each(function(idx, elem) {
					let option = $(elem);
					selectedFilters[name].push(option.val());
				});
			}

			//	Specifically for price range

			let minPriceField = $('#CCPriceRangeMin');
			let maxPriceField = $('#CCPriceRangeMax');

			if (minPriceField.val()) {
				min_price = minPriceField.val();
			}

			if (maxPriceField.val()) {
				max_price = maxPriceField.val();
			}
		});

		//	Need to show all variant cards again ebfore we re-hide any that don't match!

		$('.variant-card').closest('.box').show();

		//	Now let's loop through the actual variant cards

		$('.variant-card').each(function(index) {
			let variantCard = $(this);
			let variantCardBox = variantCard.closest('.box');

			//	Loop through any of the selected filters

			Object.entries(selectedFilters).forEach(([key, selectedValuesArray]) => {
				if (selectedValuesArray.length > 0) {
					let dataKey = 'data-' + key;
					console.log('Going to check for a `data-key` of `' + key + '`');

					if (variantCard.is('[' + dataKey + ']')) {
						console.log('This product card appears to have [' + dataKey + ']');

						//	There's probably not more than one value per array, but we should check

						let cardFilterValue = variantCard.attr(dataKey);

						if (!selectedValuesArray.includes(cardFilterValue)) {
							console.log('Product being hidden:');
							console.log(variantCardBox);
							console.log('...because', selectedValuesArray, 'includes', cardFilterValue);
							variantCardBox.hide();
						}
					}
				}
			});

			//	Now lets determine if they're within the min-max price range

			let variantPrice = parseFloat(variantCard.attr('data-price'));

			if (min_price > 0 && variantPrice < min_price) {
				console.log('Product being hidden:');
				console.log(variantCardBox);
				console.log('...because', variantPrice, '<', min_price);
				variantCardBox.hide();
			}

			if (max_price > 0 && variantPrice > max_price) {
				console.log('Product being hidden:');
				console.log(variantCardBox);
				console.log('...because', variantPrice, '>', max_price);
				variantCardBox.hide();
			}
		})

		//	NOW, let's sort all of these cards

		let sort = $('#sort-by').val();

		// Create an array to store the boxes and their prices

		var boxes = $('#product-grid .box');
		
		var boxesArray = boxes.map(function(index, box) {
			return {
				element: $(box),
				price: parseFloat($(box).find('.product-card').attr('data-price'))
			};
		}).get();

		let sorting = false;

		if (sort == 'price-ascending') {
			sorting = true;

			//	Sort low to high

			boxesArray.sort(function(a, b) {
				return a.price - b.price;
			});
		} else if (sort == 'price-descending') {
			sorting = true;

			//	Sort high to low

			boxesArray.sort(function(a, b) {
				return b.price - a.price;
			});
		}

		if (sorting) {
			boxesArray.forEach(function(item, index) {
				item.element.css('--order', index + 1);
			});
		}

		//	NOW! Is it a smart collection with rules? We're initially only going to care about sales. So:

		if (typeof collectionObj != 'undefined') {
			//	`rules` is only an object if it's a smart collection

			if (typeof collectionObj.rules != 'undefined') {
				//	collectionObj.rules is an array of Objects, so:

				console.log('It looks like this is a smart collection with rules:');
				console.log(collectionObj.rules);
				
				collectionObj.rules.forEach(function(obj) {
					if (typeof obj.column != 'undefined') {
						if (obj.column == 'variant_compare_at_price' && obj.relation == 'greater_than') {
							// We can probably assume that it's going to be a `greater_than: 1` rule;
							// Basically, if 'compare_at_price' is 'greater_than', that means it's on sale
							
							console.log('Product being hidden:');
							console.log($('.variant-card[data-sale="false"]').closest('.box'));
							console.log('...because it doesn`t appear to be on sale, and this looks like a sale collection.');

							$('.variant-card[data-sale="false"]').closest('.box').hide();
						}
					}
				});
			}
		}
	});

	//	Hide/show any variants on load
	
	$('body').trigger('filters_applied');

});

function formatMoney(cents, format) {
	if (typeof cents == 'string') { cents = cents.replace('.', ''); }
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = format;

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) { return 0; }

		number = (number / 100.0).toFixed(precision);

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	var match = formatString.match(placeholderRegex);

	if (match) {
		switch (match[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}
	}

	return formatString.replace(placeholderRegex, value);
};

jQuery(function($) {
	if ($('.horizontal-scroll-highlights').length) {

		$('.horizontal-scroll-highlights .highlight').click(function(e) {
			let parent = $(this).closest('.horizontal-scroll-highlights');
			let index = $(this).attr('data-index');
			let image = parent.find('.highlight-block[data-index="' + index + '"]');

			parent.find('.highlight').removeClass('highlighted');
			parent.find('.highlight-block').removeClass('showing');

			$(this).addClass('highlighted');
			image.addClass('showing');
		});
	}
});

jQuery(function($) {

	//	If there's no form on this page, then let's just skip the whole thing

	if ($('.invite-friend').length < 1) {
		return;
	}

	let section = $('section.invite-friend');
	let formWrapper = $('.invite-friend-form-wrapper');
	let inviteForm = $('#invite-friend-form');
	let formContainer = $('.invite-friend-form-inner');

	///
	//	Live-validate the form
	///

	inviteForm.on('paste blur change', 'input', function(e) {
		let field = $(this);
		let fieldID = field.attr('id');
		let container = field.closest('.box');
		let label = container.find('label');

		let isRequired = field.prop('required');
		let fieldVal = field.val();
		let fieldType = field.attr('type');

		showError(field, container, false);

		//	Is the field required?

		if (isRequired) {
			if (fieldVal == '') {
				showError(field, container, true);
			}

			if (fieldType == 'email' && !checkEmail(fieldVal)) {
				showError(field, container, true);
			}
		}
	});

	///
	//	Trigger live validation on initial page load
	///

	inviteForm.find('input').each(function(index) {
		let field = $(this);

		if (field.val() != null && field.val().length > 0) {
			field.blur();
		}
	});

	///
	//	Enable/disable form when it's loading
	///

	function enableForm(bool) {
		if (bool) {
			section.removeClass('sending');
		} else {
			section.addClass('sending');
		}
	}

	/////
	///
	//	FORM SUBMISSION
	///
	/////

	$(document).on('click', '#invite-friend-form button', function(e) {
		e.preventDefault();

		if (section.hasClass('sending')) {
			return false;
		}

		enableForm(false);
		
		var _form = $(this);
		
		//	Let's try to trigger those errors ON PORPOISE
		
		_form.find('input').trigger('change');
		
		if (_form.find('.error').length) {
			
			//	No dice. Errors will be shown.
			
			enableForm(true);
			return false;
		}

		//	Let's check the details of the form via the app
		
		preSendForm();
	});

	///
	//	Show/hide errors
	///

	function showError(field, container, bool) {
		if (!bool) {
			container.find('.error').remove();
		} else {
			if (!container.find('.error').length) {
				container.append('<p class="error red">' + container.attr('data-error') + '</p>');
			}
		}
	}

	///
	//	Attempt to send to Salesforce
	///

	function preSendForm() {
		let sendData = {};
		sendData['action'] = 'create';
		sendData['email'] = $('#email').val();
		sendData['customer'] = $('#customer-id').val();
		sendData['first_name'] = $('#first-name').val();
		sendData['last_name'] = $('#last-name').val();
		sendData['phone'] = $('#phone').val();

		sendAjaxRequest(sendData, 'precheck_success', 'precheck_fail');
	}

	///
	//	Submitting form was successful, so let's collapse it!
	///

	$(document.body).on('precheck_success', function(evt, data) {
		console.log(data);

		//	Let's double-check it wasn't actually an error

		if (data.response != 'success') {

			$('body').trigger('precheck_fail', [data]);
			return;
		}

		//	Maybe there was a caveat - if so, let's show the error first

		if (data.caveat) {
			alert(data.message);
		}

		//	Otherwise it looks good - let's reload!

		location.reload();
	});

	///
	//	Order lookup failed, so show an error
	///

	$(document.body).on('precheck_fail', function(evt, data) {
		console.log(data);

		//	Re-enable the form

		enableForm(true);

		//	Show the error

		alert(data.message);
	});

	/////
	///
	//	When 'Delete' is clicked
	///
	/////

	$(document).on('click', '.delete-td button', function(e) {
		e.preventDefault();

		let button = $(this);

		var confirmClick = confirm(button.attr('data-confirm'));
		
		if (!confirmClick) {
			return;
		}

		//	They've confirmed they want to continue, so let's send the 'deactivate' action

		if (section.hasClass('sending')) {
			return false;
		}

		enableForm(false);
		
		let sendData = {};
		sendData['action'] = 'delete';
		sendData['email'] = button.attr('data-email');
		sendData['customer'] = $('#customer-id').val();

		sendAjaxRequest(sendData, 'precheck_success', 'precheck_fail');
	});

	///
	//	Abstracted function for sending ajax request to app
	///

	function sendAjaxRequest(sendData, successAction, failAction) {
		enableForm(false);

		$.ajax({
			url: formWrapper.attr('data-ajax'),
			type: 'POST',
			data: sendData,
			dataType: 'json',
			
			success: function(data) {
				$('body').trigger(successAction, [data]);
			},

			error: function(xhr, ajaxOptions, thrownError) {
				console.log(xhr.response);
				console.log(xhr.message);
				console.log(thrownError);

				enableForm(true);
				
				alert(thrownError);
			}
		});
	}

	///
	//	Check email validity
	///

	function checkEmail(email) {
		let emailFilter = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		return emailFilter.test(email);
	}
});

jQuery(function($) {

	//	If there's no form on this page, then let's just skip the whole thing

	if ($('.jumptech-form').length < 1) {
		return;
	}

	//	Otherwise, carry on

	let formContainer = $('.jumptech-form');
	let contactForm = $('.jumptech-form form');

	let isSubmitting = false;

	///
	//	Now elements are hidden: If the ajax_url isn't defined, let's just bomb out - it just means we won't try to ajax-process the form
	///

	let ajaxDefined = true;

	if (typeof(jumpFormConfig) == 'undefined') {
		ajaxDefined = false;
	}

	if (typeof(jumpFormConfig) == 'undefined' || typeof(jumpFormConfig.ajax_url) == 'undefined' || jumpFormConfig.ajax_url == '') {
		ajaxDefined = false;
	}

	///
	//	'Regular' form submission: if the form has been posted, then let's collapse it
	///

	let formHasBeenPosted = (typeof(formPosted) == 'undefined') ? false : formPosted;

	if (formHasBeenPosted) {
		$('.form-internal-wrapper').slideUp();
	}

	///
	//	Live-validate the form
	///

	contactForm.on('paste blur change', 'input, textarea, select', function(e) {
		let field = $(this);
		let fieldID = field.attr('id');
		let container = field.closest('.large_form');
		let label = container.find('label');

		let isRequired = field.prop('required');
		let fieldVal = field.val();
		let fieldType = field.attr('type');

		showError(field, container, false);

		//	Is the field required?

		if (isRequired) {
			if (fieldVal == '') {
				showError(field, container, true);
			}

			if (fieldType == 'email' && !checkEmail(fieldVal)) {
				showError(field, container, true);
			}
		}
	});

	///
	//	Trigger live validation on initial page load
	///

	contactForm.find('input, select, textarea').each(function(index) {
		let field = $(this);

		if (field.val() != null && field.val().length > 0) {
			field.blur();
		}
	});

	///
	//	Enable/disable form when it's loading
	///

	function enableForm(bool) {
		if (bool) {
			formContainer.removeClass('sending');
		} else {
			formContainer.addClass('sending');
		}
	}

	/////
	///
	//	FORM SUBMISSION
	///
	/////

	$(document).on('submit', '.jumptech-form form', function(e) {
		e.preventDefault();

		if (formContainer.hasClass('sending')) {
			return false;
		}

		enableForm(false);
		
		var _form = $(this);

		isSubmitting = true;
		
		//	Let's try to trigger those errors ON PORPOISE
		
		_form.find('input, textarea, select').trigger('change');
		
		if (_form.find('.error').length) {
			
			//	No dice. Errors will be shown.
			
			enableForm(true);
			isSubmitting = false;
			return false;
		}

		//	If the AJAX URL isn't available, then we want to return TRUE to actually submit the form

		if (!ajaxDefined) {
			console.log('ajax_url is not defined, so we should just be submitting this form.');
			// contactForm.off('submit');
			// this.submit();
			// return true;
		}

		//	Otherwise, let's send the form
		
		sendForm();

		isSubmitting = false;

		return false;
	});

	///
	//	Show/hide errors
	///

	function showError(field, container, bool) {
		if (!bool) {
			container.find('.error').remove();
		} else {
			if (!container.find('.error').length) {
				container.append('<p class="error red">' + container.attr('data-error') + '</p>');
			}
		}
	}

	///
	//	Attempt to send to our app, which will send to JumpTech
	///

	function sendForm() {
		let sendData = {};
		sendData['action'] = 'submit';
		sendData['first_name'] = $('#first_name').val();
		sendData['last_name'] = $('#last_name').val();
		sendData['email'] = $('#email').val();
		sendData['phone'] = $('#phone').val();
		sendData['zip'] = $('#zip').val();
		sendData['country'] = Shopify.country;
		sendData['store'] = Shopify.shop;

		sendAjaxRequest(sendData, 'submit_success', 'submit_fail');

		return false;
	}

	///
	//	Submitting form was successful, so let's collapse it!
	///

	$(document.body).on('submit_success', function(evt, data) {
		console.log(data);

		if (data.response != 'success') {

			//	Let's see if it was something JumpTech rejected, rather than a 'regular' error

			if (data.message_key == 'send_error') {
				data.error_message = data.details.error;
			}

			$('body').trigger('submit_fail', [data]);
			return;
		}

		$('.page-copy').remove();
		$('.form-response').html(response);
		formContainer.slideUp();
	});

	///
	//	Order lookup failed, so show an error
	///

	$(document.body).on('submit_fail', function(evt, data) {
		console.log(data);

		let error = jumpFormConfig[data.message_key];

		if (data.error_message) {
			error = data.error_message;
		}

		$('#message').closest('.large_form').append('<p class="error redbg white">' + error + '</p>');
	});

	///
	//	Abstracted function for sending ajax request to app
	///

	function sendAjaxRequest(sendData, successAction, failAction) {
		enableForm(false);

		$.ajax({
			url: jumpFormConfig.ajax_url,
			type: 'POST',
			data: sendData,
			dataType: 'json',
			
			success: function(data) {
				enableForm(true);

				$('body').trigger(successAction, [data]);
			},

			error: function(xhr, ajaxOptions, thrownError) {
				console.log(xhr.response);
				console.log(xhr.message);
				console.log(thrownError);

				enableForm(true);
				
				alert(thrownError);

				// $('body').trigger(failAction, xhr.message);
			}
		});
	}

	///
	//	Check email validity
	///

	function checkEmail(email) {
		let emailFilter = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		return emailFilter.test(email);
	}

	///
	//	Safely encode attributes
	///

	function quoteattr(s, preserveCR) {
		preserveCR = preserveCR ? '&#13;' : '\n';

		return ('' + s) /* Forces the conversion to string. */
		.replace(/&/g, '&amp;') /* This MUST be the 1st replacement. */
		.replace(/'/g, '&apos;') /* The 4 other predefined entities, required. */
		.replace(/"/g, '&quot;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		/*
		You may add other replacements here for HTML only 
		(but it's not necessary).
		Or for XML, only if the named entities are defined in its DTD.
		*/ 
		.replace(/\r\n/g, preserveCR) /* Must be before the next replacement. */
		.replace(/[\r\n]/g, preserveCR);
	}
});

jQuery(function($) {

	//	Add a CSS var for the header height so we can calculate the nav height on mobile

	let body = $('body');
	let header = $('#shopify-section-header');

	function getHeaderHeight() {
		if (header.length) {
			let headerHeight = header.outerHeight() / 16;

			body.attr('style', '--header-height: ' + headerHeight + 'rem;');
		}
	}

	getHeaderHeight();

	$(window).on('resize', _debounce(getHeaderHeight, 250));

	//	When hamburger is clicked

	let hamburger = $('.header__toggle');
	let nav = $('.header__nav');

	hamburger.click(function(evt) {
		hamburger.toggleClass('header__toggle--open');
		nav.toggleClass('header__nav--open');
	});

	//	When a meganav item is hovered, listen for the change and add a `showing-meganav` class to the body

	var targetElements = $('.tmenu_item_submenu_mega_position_fullwidth');

	targetElements.each(function(index, element) {

		// Create a new MutationObserver
		// 
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {

				// Check if the class '.tmenu_item_active' has been added or removed
				
				if ($(mutation.target).hasClass('tmenu_item_active')) {
					$('body').addClass('showing-meganav');
				} else {
					$('body').removeClass('showing-meganav');
				}
			});
		});

		// Define the configuration options for the observer

		var config = { attributes: true };

		// Start observing the target element
		
		observer.observe(element, config);
	});

	///
	//	On mobile, of a nav item with an expand indicator is clicked, then don't click the link but the expand item instead
	///

	/*let mobileInterval = setInterval(checkMobileNav, 500);
	let checkCount = 1;

	function checkMobileNav() {
		console.log('Running a check for mobile nav:', checkCount);
		let indicatorLength = $('.header__nav .tmenu_app_mobile > .tmenu_item > .tmenu_item_link > .tmenu_indicator').length;

		if (indicatorLength > 0) {
			clearInterval(mobileInterval);

			modifyMobileNav();

			return;
		}

		checkCount++;

		if (checkCount >= 10) {
			console.log('Unable to find a mobile nav, so no longer checking after 10 iterations');
			clearInterval(mobileInterval);
			return;
		}
	}

	function modifyMobileNav() {
		//	Need to stop default propagation of the child `.tmenu_indicator` click back up to the parent link; otherwise we end up with infinite recursion
		
		$('.tmenu_indicator').click(function(evt) {
			evt.stopPropagation();
		});

		$('.header__nav .tmenu_app_mobile > .tmenu_item > .tmenu_item_link > .tmenu_indicator').each(function(index, elem) {
			let indicator = $(this);
			let link = $(this).closest('.tmenu_item_link');

			link.click(function(evt) {
				evt.preventDefault();

				let _arrow = $(this).find('.tmenu_indicator');

				_arrow.trigger('click');
			});
		});
	}*/
});

jQuery(function($) {

	$('body').on('click', '.thumbnails .thumb', function (e) {
		e.preventDefault();

		let thumb = $(this);

		$('.thumb').removeClass('is-active');
		thumb.addClass('is-active');

		$('.product-media').removeClass('is-active');

		let targetImage = $('.product-media[data-media-id="' + thumb.attr('data-media-id') + '"]');
		targetImage.addClass('is-active');
	});

	///
	//	On resize, get the distance of the .product-media block on the product page
	///

	function getProductMediaTop() {
		if ($('.spaced-section.product').length) {
			let mediaTop = $('.spaced-section.product').offset().top / 16;

			$('.box.product-media').attr('style', '--top: ' + mediaTop + 'rem;');
		}
	}

	getProductMediaTop();

	$(window).on('resize', _debounce(getProductMediaTop, 200));

	//	The '--top' attribute will be lost when the PDP is updated via ajax (e.g. when fetching a variant), so we need to account for that

	$(document.body).on('variant_changed_complete', function(evt) {
		getProductMediaTop();
	});
});

jQuery(function($) {
	//	If there's no .product-media, then this isn't a PDP, so we shouldn't do any of this

	if ($('.product-media').length < 1) {
		return;
	}

	///
	//	##############################################################################
	//	##	Before we do anything, we need to check for out-of-stock items! BUT!	##
	//	##	Because Shopify's variant objects are HORRIBLE, there's no way to tell	##
	//	##	Whether a particular 'option' is available, as that only contains its	##
	//	##	NAME, whereas the product.variants contain all the stock info, but NOT	##
	//	##	the NAME of the actual VARIANT TYPE. And there's no reliable way to 	##
	//	##	associate the two, so... gross.											##
	//	##############################################################################
	///

	let selectedOptions = null;
	let currentVariant = null;

	let buyButtonsBlock = $('.buy-buttons-block');
	let addButtons = buyButtonsBlock.find('.product-add');
	let soldOutButton = buyButtonsBlock.find('.button--sold-out');

	let variantSelect = $('.variant-selector');

	//	If there's only one option in the .variant-selector, then there's only one variant for the product, so we can skip ALL of this
	
	if ($('.variant-selector option').length == 1) {
		return;
	}

	//	When the variant is changed, we need to update some PDP details
	
	$('.product-info').on('change', '.opt-btn', function(evt) {
		if ($('.main-content-wrapper').hasClass('loading')) {
			return;
		}

		$('body').trigger('variant_changed');
	});

	$(document.body).on('variant_changed', function(evt) {
		//	We're going to hide the add-to-cart form and the sold-out button while we determine what's available

		//	Update the currently-selected options
		
		updateOptions();

		//	Update the current variant

		updateCurrentVariant();

		//	Update the variant statuses

		updateVariantStatuses();

		// console.log('currentVariant:', currentVariant);

		//	Now that these have been run, we can determine what buttons to show, what parts to update, etc.

		if (!currentVariant) {
			checkCurrentVariantAvailable();
		} else {
			updateURL();
			
			variantSelect.val(currentVariant.id).trigger('change');

			renderProductInfo();
		}

		//	The product thumbnaiuls may change based on the selected options

		maybeChangeThumbnails();

		$('body').trigger('variant_changed_complete');
	});

	///
	//	Update the currently-selected selectedOptions
	//	Updates `selectedOptions` to array of options; e.g. ["9 kg", "White"]
	///

	function updateOptions() {
		selectedOptions = Array.from($('.product-options fieldset, .product-options select').get(), function(element) {
			if (element.tagName === 'SELECT') {
				return element.value;
			}
			if (element.tagName === 'FIELDSET') {
				//	Find all inputs where the radio button is checked

				// return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
				
				var radios = Array.from(element.querySelectorAll('input'));

				var checkedRadio = radios.find(function(radio) {
					return radio.checked;
				});

				if (checkedRadio !== undefined) {
					return checkedRadio.value;
				} else {
					return false;
				}
			}
		});
	}

	///
	//	Update the current variant
	//	Updates `currentVariant` to an object 
	///

	function updateCurrentVariant() {
		//	This will set the current variant by looping through ALL the variants and picking the one
		//	where the `options` match the currently-selected options
		//	NOTE: If there are no variants that match the selected options, `currentVariant` becomes undefined

		currentVariant = json_product.variants.find(function(variant) {
			return !variant.options
				.map(function(option, index) {
					return selectedOptions[index] === option;
				})
				.includes(false);
		});
	}

	///
	//	Update the variant statuses
	//	Loops through the different .option-selectors (which contain the variant options) and enables/disables them
	///

	function updateVariantStatuses() {
		//	First let's find the matching `option1` options (assuming it's a washing machine, this should be the load size, e.g. '9 kg')

		let selectedOptionOneVariants = json_product.variants.filter(
			function (variant) {
				return $('.option-selector input:checked').val() === variant.option1
			}
		);

		let inputWrappers = $('.option-selector');

		//	Now let's go through ALL the available options (e.g. load size and colour)

		inputWrappers.each(function(index, elem) {
			//	We're skipping over the first set of options, as that's already been defined in `selectedOptionOneVariants`

			if (index === 0) {
				return;
			}

			//	Find all the inputs within the current `.option-selector`

			let inputs = $(elem).find('input[type="radio"], option');

			//	Find the previous row of options' selected value; e.g. if we're on the 'Colour' options, then the previous row is 'Load Size'
			
			let previousOptionSelected = inputWrappers.eq(index - 1).find(':checked').val();
			
			//	

			let availableOptionInputsValue = selectedOptionOneVariants
				.filter(function(variant) {
					return variant.available && variant['option' + index] === previousOptionSelected;
				})
				.map(function(variantOption) {
					return variantOption['option' + (index + 1)];
				});

			//	Determine if various inputs should be disabled or enabled

			setInputAvailability(inputs, availableOptionInputsValue);
		});
	}

	///
	//	Set the availability of certain inputs
	//	Toggles the `.is-unavailable` class on inputs if their options are not available
	///

	function setInputAvailability(elementList, availableValuesList) {
		elementList.each(function(index, elem) {
			let value = elem.getAttribute('value');
			let availableElement = availableValuesList.includes(value);

			//	Assume that the element is an input rather than a select or option (for now)

			$(elem).toggleClass('is-unavailable', !availableElement);
		});
	}

	///
	//	Update the URL
	///

	function updateURL() {
		//	If no variant was found, then bomb out

		if (!currentVariant) {
			return;
		}

		//	`item` is defined within Shopify. It's the most easily-accessible way to grab the root URL of the live store, but we could define our own

		window.history.replaceState({}, '', item.URL + '?variant=' + currentVariant.id);
	}

	///
	//	Update a bunch of things on the page
	///

	let xhr = null;

	function renderProductInfo() {
		$('.main-content-wrapper').addClass('loading');

		let requestURL = item.URL + '?variant=' + currentVariant.id + '&ajax=true';

		xhr = $.ajax({
			url: requestURL,
			type: 'GET',
			
			success: function(data) {

				//	Replace title

				let title = $('.product-title');
				let newTitle = $(data).find('.product-title');
				
				title.replaceWith(newTitle);

				//	Product dimensions (if applicable)
				//	CAVEAT: This only works if the CURRENTLY-VIEWED PRODUCT also has dimensions

				let dimensions = $('.product-dimensions');
				
				if (dimensions.length) {
					let newDimensions = $(data).find('.product-dimensions');
					dimensions.replaceWith(newDimensions);
				}

				//	Replace price

				let price = $('.product-price');
				let newPrice = $(data).find('.product-price');
				
				price.replaceWith(newPrice);

				//	Replace the ENTIRE sticky bar

				let stickyDetails = $('.sticky-details');
				let newStickyDetails = $(data).find('.sticky-details');

				stickyDetails.replaceWith(newStickyDetails);

				//	Replace media gallery - Note that the main wrapper has the class `.product-media`, 
				//	but so does every image (annoyingly); hence the `.box` selector

				let media = $('.box.product-media');
				let newMedia = $(data).find('.box.product-media');

				media.replaceWith(newMedia);

				//	Rather than REPLACE the buy buttons, we're going to check if anything is showing or hidden

				let newBuyButtonsBlock = $(data).find('.buy-buttons-block');

				let newAddButtons = newBuyButtonsBlock.find('.product-add');
				let newSoldOutButton = newBuyButtonsBlock.find('.button--sold-out');

				addButtons.hide();
				soldOutButton.hide();

				if (newAddButtons.length > 0) {
					addButtons.show();
				}

				if (newSoldOutButton.length > 0) {
					soldOutButton.show();
				}

				//	Let's determine if the currentVariant is actually available

				checkCurrentVariantAvailable();

				//	Remove the loading class

				$('.main-content-wrapper').removeClass('loading');

				$('body').trigger('variant_changed_complete');
			},

			error: function(xhr, ajaxOptions, thrownError) {
				$('.main-content-wrapper').removeClass('loading');

				console.log(xhr.response);
				console.log(xhr.message);
				console.log(thrownError);

				alert(thrownError);
			}
		});
	}

	///
	//	Check if the currentVariant is actually available
	///

	function checkCurrentVariantAvailable() {
		// console.log('Checking if the currentVariant is available...');

		if (!currentVariant || !currentVariant.available) {
			// console.log('currentVariant is NOT available.');
			//	So, the variant that's 'selected' isn't actually available. For now, let's assume we only have TWO options available (load size & colour);
			//	We only want to check the 2nd option - from the first row of options, the unavailable one should never be selectable.

			let unavailableOptions = $('.option-selector__btns .is-unavailable:checked');	//	Shouldn't choose anything from the option1 row

			//	Get the next available option, and select it instead

			unavailableOptions.each(function(index, option) {
				$(option).prop('checked', false);

				let optionParent = $(option).closest('.option-selector__btns');

				let availableOption = optionParent.find('.opt-btn:not(.is-unavailable)').first();

				if (xhr) {
					xhr.abort();
				}

				$('.main-content-wrapper').removeClass('loading');
				
				availableOption.prop('checked', true).trigger('change');
			});
		}
	}

	///
	//	Trigger a change on page load
	///

	if (window.location.search.indexOf('ajax=true') !== -1) {
		console.log('Page content loaded by AJAX');
	} else {
		//	Page loaded 'naturally', so only triggering variant change once
		
		$('.opt-btn:checked').trigger('change');
	}

	///
	//	Change the 'Color' thumbnails depending on the selected variant options
	///

	function maybeChangeThumbnails() {
		//	For now, let's just assume we're checking the first option

		let firstOptionSelected = $('input.opt-1:checked');

		//	Get the value of that and find all matching variants

		let firstOptionSelectedName = firstOptionSelected.val();

		//	Find the matching variants

		let matchingVariants = variant_products.filter(obj => obj.option1 === firstOptionSelectedName);

		if (matchingVariants && matchingVariants.length > 0) {
			matchingVariants.forEach(function(varObj) {
				let objColor = varObj.option2;

				let input = $('input[data-option="2"][value="' + objColor + '"]');
				let label = input.next('label');
				let thumb = label.find('.thumbnail');

				thumb.attr('src', varObj.featured_image.src);
				thumb.attr('srcset', varObj.featured_image.src);
			});
		}

	}
});

///
//	Define a global function for returning a formatted price based on a number (in pence / cents)
///

function returnPrice(price) {
	price = price / 100;
	price = globalObj.currency_symbol + price.toFixed(2);
	return price;
}

///
//	Define a global function for checking to see if arrays match
///

function arraysMatch(arr1, arr2) {
	return arr1.length === arr2.length && arr1.every(function(value) {
		return arr2.includes(value);
	});
}

jQuery(function($) {
	if ($('.scrolling-highlights').length) {
		let observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						let highlightNum = $(entry.target).attr('data-highlight');
						
						$('.scrolling-highlights .highlight').removeClass('highlighted');
						
						// Add the highlighted class to the matching highlight

						$('.scrolling-highlights .highlight-' + highlightNum).addClass('highlighted');
					}
				});
			},
			{
				root: null, // Observing within the viewport
				rootMargin: '-30px 0px -70% 0px', // 30px margin from top
				threshold: 0, // Trigger as soon as it enters
			}
		);

		// Observe each content-box
		$('.scrolling-highlights .highlight-block').each(function() {
			observer.observe(this);
		});
	}
});

jQuery(function($) {

	let $body = $('body');

	let header = $('.header');
	let modal = $('.search-modal');

	let modalOpenClass = 'search-modal--open';

	let searchButton = $('.header__search-btn');

	let input = modal.find('.search-form__input');

	if (!searchButton.length || !header.length) {
		return;
	}

	searchButton.click(function(evt) {
		toggleSearchModal();
	});

	function toggleSearchModal() {
		modal.toggleClass(modalOpenClass);

		setTimeout(function() {
			if (modal.hasClass(modalOpenClass)) {
				input.focus();
			} else {
				input.blur();
			}
		}, 100);
	}

	//	The `.search-modal` element occupies the entire viewport, so clicking anywhere on it will close it

	$body.on('click', '.search-modal--open', function(evt) {
		let targetModal = $(this).get(0);
		toggleSearchModal();
	});
	
	//	The `.search-modal` element needs to contain a `.search-modal__content` that will prevent the propagation of the closing click on the parent modal

	$body.on('click', '.search-modal__content', function(evt) {
		evt.stopPropagation();
	});

	///
	//	Switch if escape key hit
	///
	
	document.onkeydown = function(evt) {
		evt = evt || window.event;
		
		//	Escape = close search modal

		if (evt.keyCode == 27) {
			if (modal.hasClass(modalOpenClass)) {
				toggleSearchModal();
			}
		}
	};

	///
	//	Use AJAX to pull search results while typing
	///

	let searchTimeoutThrottle = 500;
	let searchTimeoutID = -1;
	let currReqObj = null;

	let modalContent = $('.search-modal__content');
	let quickLinks = modalContent.find('.quick-links');
	let resultsDiv = modalContent.find('#search-results');

	let form = $('form.search-form');

	let searchAction = form.attr('action');

	let noResultsString = form.attr('data-no-results');
	let seeAllString = form.attr('data-see-all');
	let priceFormat = form.attr('data-format');
	let fromString = form.attr('data-from');

	$('#SearchModal .search-form__input').on('keyup change', function(evt) {
		let search = $(this);
		let searchVal = search.val();

		//	Only search if search string longer than 2, and it's actually changed (i.e. it's not the same string as the last time we checked)

		if (searchVal.length > 2 && searchVal != search.data('oldval')) {
			//	Reset previous value
			
			search.data('oldval', searchVal);
			
			//	Kill any outstanding AJAX requests
			
			if (currReqObj != null) {
				currReqObj.abort();
			}
			
			//	Kill previous search timeout
			
			clearTimeout(searchTimeoutID);
			
				//	URL for the full search page
			
			var linkURL = searchAction + '?type=product&q=' + searchVal;
			
			//	Hide quick-links and show loader
			
			quickLinks.hide();

			if (!modalContent.find('.loader').length) {
				modalContent.append('<div class="loader white"></div>');
			}
			
			// Perform the search (after a timeout)

			searchTimeoutID = setTimeout(function() {
				//	Ajax hit on search page

				currReqObj = $.ajax({
					url: searchAction + '/suggest.json',
					type: 'GET',
					dataType: 'json',
					data: {
						'q': searchVal,
						'resources': {
							'type': 'product',
							'limit': 6,
							'options': {
								'unavailable_products': 'hide',
								'fields': 'title,product_type,variants.title,vendor'
							}
						}
					},

					success: function(data) {

						//	Clear the AJAX request

						currReqObj = null;

						//	Empty the results

						resultsDiv.empty();

						//	Get the products

						let products = data.resources.results.products;

						//	If the length of `products` is 0, then we've got no results

						if (!products) {
							resultsDiv.html('<div class="box twelve note">' + noResultsString + '</div>');
							return;
						}

						//	Otherwise, we've got some results, so let's loop through them

						$.each(products, function(index, product) {
							console.log(product);

							//	Create the result container

							var row = $('<a class="search-result box four marginy-16 nounderline flex"></a>').attr('href', product.url);

							//	Add the image

							row.append('<div class="img"><img src="' + product.image + '" /></div>');
							
							//	Create the details container

							var details = $('<div class="details"></div>');
							row.append(details);
							
							details.append('<div class="title">' + product.title + '</div>');

							//	Add the price

							var price = $('<div class="price product-price">');
							details.append(price);

							//	If the price_max and price_min aren't the same, then we'll have a 'FROM' label

							if (product.price_max != product.price_min) {
								$('<span class="price-from">').html(fromString).appendTo(price);
								price.append(' ');
							}

							$('<span class="price-amount strong">').html(formatMoney(product.price_min, priceFormat)).appendTo(price);
							
							if (product.compare_at_price_min > product.price_min) {
								price.append(' ');
								$('<s class="price-compare grey-3">').html(formatMoney(product.compare_at_price_min, priceFormat)).appendTo(price);
							}

							//	Add this row to the #search-results container

							resultsDiv.append(row);
						});

						modalContent.find('.loader').remove();

						resultsDiv.append('<a href="' + linkURL + '" class="box twelve note">'  + seeAllString + '</a>');
					}
				});
			}, searchTimeoutThrottle);

		} else if ($(this).val().length <= 2) {
			//	Deleted text? Clear results and re-show the quick links

			quickLinks.show();
			resultsDiv.empty();
			modalContent.find('.loader').remove();
		}

	}).attr('autocomplete', 'off').data('oldval', '').on('focusin', function() {
		//	Focus, show results
		
		resultsDiv.fadeIn(200);
	});

	// .on('click', function(e) {
	// 	//	Click, prevent body from receiving click event
	// 	e.stopPropagation();
	// });
	
	// //	Search box should mimic live search string: products only, partial match

	// $('.search-form, #search-form').on('submit', function(e){
	// 	e.preventDefault();
	// 	var term = '*' + $(this).find('input[name="q"]').val() + '*';
	// 	var linkURL = $(this).attr('action') + '?type=product&q=' + term;
	// 	window.location = linkURL;
	// });
});

jQuery(function($) {

	///
	//	Basically signup via ajax is impossible with Shopify, as it may through a ReCaptcha which will bork the whole thing
	//	As such, we're just going to listen for the existence of a 'thanks' element asnd put its contents into a modal
	///
	
	if ($('.newsletter-response').length > 0) {
		let markup = $('.newsletter-response:first').html();

		//	Trigger a dialog with the thanks message as the content

		$('body').trigger('show_dialog', { dialog: '#signup-thanks-modal', content: markup } );
	}
});

jQuery(function($) {

	function initSlideShows() {
		$('.slideshow').each(function() {
			///
			//	Set up an IntersectionObserver to listen for native-CSS product-row swipes and change the dots accordingly
			///

			let slideshow = this;
			let jSlideshow = $(this);
			let productSlides = slideshow.querySelectorAll('.slide');
			let slideWidth = $(productSlides).width();

			jSlideshow.attr('data-current-slide', 0);
			let numSlides = jSlideshow.attr('data-slides');

			let arrowsContainer = jSlideshow.closest('.product-row').find('.product-row-arrows .arrows');
			let arrowPrev = arrowsContainer.find('.arrow-prev');
			let arrowNext = arrowsContainer.find('.arrow-next');

			//	Add click interaction for the arrows

			arrowsContainer.find('.arrow').click(function(evt) {
				let dir = parseInt($(this).attr('data-direction'));

				let nextSlide = parseInt(jSlideshow.attr('data-current-slide')) + dir;
				if (nextSlide >= numSlides) {
					nextSlide = numSlides;
				} else if (nextSlide <= 0) {
					nextSlide = 0;
				}

				//	Update the current slide value

				jSlideshow.attr('data-current-slide', nextSlide);

				let scrollAmount = nextSlide * slideWidth;
				jSlideshow.scrollLeft(scrollAmount);

				updateScrollArrows(jSlideshow, arrowsContainer, arrowNext, arrowPrev);
			});

			updateScrollArrows(jSlideshow, arrowsContainer, arrowNext, arrowPrev);
		});
	}

	$(window).on('resize', _debounce(initSlideShows, 250));

	initSlideShows();

	///
	//	Update scroll arrow classes - mostly just for scrollable product rows (rather than ANY slideshow)
	///

	function updateScrollArrows(jSlideshow, arrowsContainer, arrowNext, arrowPrev) {
		let winWidth = $(window).width();

		if (arrowsContainer.hasClass('noclick')) {
			return;
		}

		arrowPrev.removeClass('inactive');
		arrowNext.removeClass('inactive');

		arrowsContainer.addClass('noclick');

		setTimeout(function() {
			let scrollPos = jSlideshow.scrollLeft();
			let amountRemaining = jSlideshow.prop('scrollWidth') - scrollPos;

			//	Checking within a tolerance of 50px either at the beginning or end, just so there's a bit of leeway

			if (amountRemaining <= (winWidth + 50)) {
				arrowNext.addClass('inactive');
			}

			if (scrollPos <= 50) {
				arrowPrev.addClass('inactive');
			}

			arrowsContainer.removeClass('noclick');
		}, 300);
	}
});

let originalCTAVisible;
let ctaObserver;
let footerObserver;

jQuery(function($) {

	function setupStickyCTA() {
		if ($('.product-form-block .js-product-form').length) {

			//	Now that we have a sticky buy button, let's create an IntersectionObserver that hides the sticky button when the fake CTA is on the page

			originalCTAVisible = false;

			if (typeof ctaObserver == 'object') {
				ctaObserver.disconnect();
			}

			ctaObserver = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function(entry) {
					if (entry.isIntersecting) {
						$('.js-product-form').removeClass('sticky-buy-bar');
						originalCTAVisible = true;
					} else {
						$('.js-product-form').addClass('sticky-buy-bar');
						originalCTAVisible = false;
					}
				});
			});

			ctaObserver.observe($('.placeholder-button').get(0));

			//	Similarly, create an IntersectionObserver that hides the sticky CTA once the footer is in view

			if (typeof footerObserver != 'object') {
				footerObserver = new IntersectionObserver(function(entries, observer) {
					entries.forEach(function(entry) {
						if (entry.isIntersecting) {
							$('.js-product-form').removeClass('sticky-buy-bar');
						} else {
							//	The 'original' add-to-cart CTA near the top of the page shouldn't be on-screen at the same time as the footer, so this is a safe check

							if (originalCTAVisible) {
								return;
							}

							$('.js-product-form').addClass('sticky-buy-bar');
						}
					});
				});

				footerObserver.observe(document.getElementById('shopify-section-footer'));
			}
		}
	}

	setupStickyCTA();

	///
	//	At the same time, we want to set up a `--min-height` for the `buy-buttons-block` whenever its height has changed
	///

	let previousHeight = 0;

	function buyButtonsMinHeight() {
		if ($('.product-form-block .js-product-form').length) {
			let targetNode = $('.buy-buttons-block').get(0);

			let previousHeight = targetNode.offsetHeight;
			targetNode.style.setProperty('--min-height', `${previousHeight}px`);

			let observer = new MutationObserver(mutationsList => {
				for (let mutation of mutationsList) {
					//	Check if the mutation affects the child list or the subtree of the target node
					
					if (mutation.type === 'childList' || mutation.type === 'subtree') {
						//	Get the new height of the target element
						
						let newHeight = targetNode.offsetHeight;
						
						//	Update the custom CSS property with the new height
						
						if (newHeight > previousHeight) {
							targetNode.style.setProperty('--min-height', `${newHeight}px`);
					
							//	Update the previous height
							
							previousHeight = newHeight;
						}
					}
				}
			});

			//	Configuration of the observer:
			//	Observe child list changes and subtree changes
			
			let config = { childList: true, subtree: true };

			//	Start observing the target node
			
			observer.observe(targetNode, config);
		}
	}

	buyButtonsMinHeight();
});